import { SubmissionError } from 'redux-form'

export function request(type, body) {
  return {
    type,
    body,
  }
}

export function success(type, response) {
  return {
    type,
    response,
  }
}

export function failure(type, error) {
  return {
    type,
    error,
  }
}

export function reduxFormFailure(dispatch, type, error) {
  if (!error || !error.errors) {
    dispatch({ type, otherErrors: { errors: [], statusText: 'ClientError', status: 0 } })
    throw new SubmissionError({ _error: 'error.global.submission' })
  }

  const valErrors = { errors: [], statusText: error.statusText, status: error.status }
  const otherErrors = { errors: [], statusText: error.statusText, status: error.status }
  if (Array.isArray(error.errors)) {
    error.errors.forEach(item =>
      item.errorType === 'ValidationError'
        ? valErrors.errors.push(item)
        : otherErrors.errors.push(item)
    )
  } else if (error.errors.errorType === 'ValidationError') {
    valErrors.errors.push(error.errors)
  } else {
    otherErrors.errors.push(error.errors)
  }

  dispatch({ type, otherErrors })

  if (valErrors.errors.length > 0) {
    const vE = {}
    valErrors.errors.forEach(item => {
      vE[item.field] = item.message
      // SB: Uncomment if we want form-wide validation errors to be passed through.
      // vE['_error'] = item._error || vE['_error']
    })
    throw new SubmissionError(vE)
  } else if (otherErrors.errors.length > 0) {
    const oE = {}
    otherErrors.errors.forEach(item => {
      if (item.errorType === 'NotAcceptableError') {
        const msg = (item && item.message ? String(item.message) : '').toLowerCase()
        if (msg.includes('captcha')) {
          oE._error = 'error.global.submission'
        } else {
          oE._error = 'global.label.timeBlock'
        }
      } else {
        oE._error = 'error.global.submission'
      }
      // oE._error = item.message
    })
    throw new SubmissionError(oE)
  }
}
